// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"bb3c28e0","191":"c7361195","203":"2f151ae2","555":"ac518f51","648":"32f08b38","838":"b9ea5157","925":"fecaf553"}[chunkId] + ".css";
};